<template>
  <div
    class="dashboard-app-wrapper"
    id="app"
  >
    <FailedPaymentBanner v-if="shouldShowFailedPaymentBanner" />

    <!-- Navbar is always present, each tab is made into other route-->
    <div class="dashboard-body-wrapper">
      <Navbar
        :class="{
          'navbar-extended': !isNavbarCollapsed,
        }"
        :topBannerShown="shouldShowFailedPaymentBanner"
        v-if="isNavbarVisible"
      />
      <router-view
        class="dashboard-page-wrapper"
        :class="{
          'wrapper-rounded-deprecated': isNavbarVisible,
          scroll: isScrollNeeded,
          'under-top-banner': shouldShowFailedPaymentBanner
        }"
        v-if="loaded && !shouldBlockMobile"
      />
    </div>

    <MobileBlocker v-if="shouldBlockMobile" />
    <UpdateAvailableBar v-if="needReload" />

    <ChooseDashboardLanguageModal v-if="isInitialLanguageModalShown" />

    <portal-target name="iqos-modal-portal"> </portal-target>

    <portal-target name="iqos-backdrop-alpha"> </portal-target>

    <div class="toasts-container gap-row-xs">
      <IQOSToast
        v-for="(toast, idx) in notificationToasts"
        :key="idx"
        @close="onToastClosed(idx)"
        :variant="toast.variant"
        :content="toast.content"
      />
    </div>

    <div
      class="fuck-russia"
      v-if="fuck_russia"
    >
      <div class="qrw-heading-md">🇺🇦 Русский корабль иди нахуй!</div>
      <div
        class="gap-row-1xs"
        style="text-align: center; align-items: center; justify-content: center;"
      >
        <div class="qrw-paragraph-md">
          QRWaiter остановил работу в России из-за вторжения на территорию
          мирного народа Украины.
        </div>
        <div class="qrw-paragraph-md">
          Войска РФ бомбят города и убивают мирных жителей!
        </div>
        <div class="qrw-paragraph-md">Узнавайте правду из независимых СМИ:</div>
        <div class="qrw-paragraph-md">
          <a
            href="https://war.ukraine.ua/"
            class="green-5-color"
          >Official Ukraine War Info</a>
        </div>
        <div class="qrw-paragraph-md">
          <a
            href="https://www.bbc.com/ukrainian/ukraine_in_russian"
            class="green-5-color"
          >BBC</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/supernavbar/Navbar.vue'
import MobileBlocker from '@/components/MobileBlocker.vue'
import ErrorBar from '@/components/ErrorBar.vue'

import UpdateAvailableBar from '@/components/UpdateAvailableBar.vue'

import NotificationToast from '@/components/NotificationToast.vue'

import IQOSToast from '@/components/IQOSToast.vue'

import SuperaccessService from '@/services/superaccess'

import ChooseDashboardLanguageModal from '@/components/modals/ChooseDashboardLanguageModal.vue'

import FailedPaymentBanner from '@/components/superbilling/FailedPaymentBanner.vue'

import moment from 'moment'

export default {
  data() {
    return {
      loaded: false,

      fuck_russia: false
    }
  },
  watch: {
    isLoggedIn() {
      this.fuckRussia()
    },
    isNavbarCollapsed() {
      if (this.isNavbarCollapsed) {
        window.document.body.style.backgroundColor = 'var(--qrw-background-base-inverse-primary)'
      } else {
        window.document.body.style.backgroundColor = 'var(--foundation-gray-900-color)'
      }
    }
  },
  computed: {
    isScrollNeeded() {
      return this.$route.name == 'register' || this.$route.name == 'login'
    },
    isNavbarVisible() {
      if (
        [
          'login',
          'confirm',
          'deposit_form',
          'confirm_employee',
          'confirm_register',
          'register',
          'password_recovery_confirm',
          'password_recovery'
        ].includes(this.$route.name)
      ) {
        return false
      }

      return this.$store.state.loggedIn
    },
    shouldBlockMobile() {
      if (this.$route.name == 'confirm' || this.$route.name == 'deposit_form') return false

      return this.isMobile
    },
    isMobile() {
      return window.screen.width < 576
    },
    global_error() {
      return this.$store.state.error
    },
    needReload() {
      return this.$store.state.compatibility.need_reload
    },
    onboarding() {
      const cafe = this.$store.state.cafe
      return !cafe ? false : !cafe.onboarding_complete
    },
    notificationToasts() {
      return this.$store.state.ui.toasts
    },
    isInitialLanguageModalShown() {
      return this.isNavbarVisible && this.$store.state.loggedIn && !this.$store.state.owner.dashboard_language
    },
    isLoggedIn() {
      return this.$store.state.loggedIn && this.$store.state.owner
    },
    isNavbarCollapsed() {
      return this.$store.state.ui.navbar_collapsed
    },
    shouldShowFailedPaymentBanner() {
      const cafe = this.$store.state.cafe

      if (!this.isNavbarVisible) return false

      if (!cafe || !cafe._id) return false

      if (this.$route.name == 'superbilling') return false

      return cafe.billing && cafe.billing.auto_payment_enabled && cafe.billing.auto_payment_attempts > 0
    }
  },
  methods: {
    checkLocale() {
      if (this.$store.state.owner.dashboard_language) {
        this.$i18n.locale = this.$store.state.owner.dashboard_language
        return
      }

      let saved_locale = window.localStorage.getItem('locale')

      if (saved_locale == 'uk') {
        window.localStorage.removeItem('locale')
        saved_locale = null
      }

      const moment_locale_mappings = {
        ua: 'uk',
        en: 'en',
        ru: 'ru'
      }

      if (saved_locale) {
        this.$i18n.locale = saved_locale
      } else {
        if (!this.$store.state.loggedIn) {
          this.$i18n.locale = 'ua'
          window.localStorage.setItem('locale', this.$i18n.locale)
          return
        }

        const user_country = this.$store.state.owner.country.toLowerCase()

        if (this.$i18n.availableLocales.includes(user_country)) {
          this.$i18n.locale = user_country
        } else {
          this.$i18n.locale = 'en'
        }

        window.localStorage.setItem('locale', this.$i18n.locale)
      }

      moment.locale(moment_locale_mappings[this.$i18n.locale])
    },
    onToastClosed(idx) {
      this.$store.commit('ui/removeToast', {
        index: idx
      })
    },
    bootIntercom() {
      this.$store.dispatch('bootIntercom')
    },
    fuckRussia() {
      if (SuperaccessService.get()) {
        return
      }

      if (!this.$store.state.owner) return

      if (this.$store.state.owner.country == 'RU') {
        if (this.$store.state.owner._id == '5f140f7bd7ca320f2ff653d7') return

        this.fuck_russia = true
        this.loaded = false
      }
    }
  },
  mounted() {
    this.$store
      .dispatch('init', this.$route.query.admin_cafe_id)
      .then(ok => {
        //We are logged in, go on
        this.loaded = true

        this.checkLocale()
        this.fuckRussia()
      })
      .catch(error => {
        if (
          ![
            'login',
            'confirm',
            'deposit_form',
            'poster_redirect',
            'confirm_employee',
            'confirm_register',
            'password_recovery_confirm',
            'password_recovery',
            'register'
          ].includes(this.$route.name)
        ) {
          // this.$router.push("/login");
          this.$router.push('/login')
        }
        this.loaded = true
        this.checkLocale()
      })
      .finally(() => {
        // setTimeout(this.bootIntercom, 500);
      })

    if (this.$route.query.superadmin_data) {
      SuperaccessService.addSession(this.$route.query.superadmin_data)
    }

    this.$store.dispatch('compatibility/init')
  },
  components: {
    Navbar,
    MobileBlocker,
    ErrorBar,
    UpdateAvailableBar,
    NotificationToast,
    IQOSToast,
    ChooseDashboardLanguageModal,
    FailedPaymentBanner
  }
}
</script>

<style scoped>
.navbar-extended {
  /* animation: navbar-extended 0.3s ease; */
}

.under-top-banner {
  height: calc(100% - 44px);
}
</style>

<style>
/* Dashboard Structure Classes */

.dashboard-app-wrapper {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.dashboard-page-wrapper.scroll {
  overflow-y: auto;
}

.dashboard-body-wrapper {
  display: flex;
  height: 100%;
}

.dashboard-page-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  overflow-y: hidden;

  background: var(--qrw-background-base-secondary);
  clip-path: border-box;

  position: relative;
}

.wrapper-rounded {
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

.toasts-container {
  position: fixed;
  z-index: 1500;
  right: 24px;
  top: 24px;
}

.fuck-russia {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 7000;

  background: var(--qrw-background-base-inverse-primary);
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;

  flex-direction: column;
  row-gap: 8px;

  color: var(--qrw-content-base-inverse-primary);
}

.system-settings-disabled {
  opacity: 0.5;
  touch-action: none;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
